import React from "react";
import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const location = useLocation();
  const orderNumber = location.state?.orderNumber;
  const hasConfirmation = Boolean(orderNumber);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="payment-success" id="main-content">
      <section
        className="payment-success__card"
        aria-labelledby="payment-success-title"
      >
        <div className="payment-success__mark" aria-hidden="true">
          ✓
        </div>
        <p className="payment-success__eyebrow">{siteConfig.brandName}</p>
        <h1 id="payment-success-title">
          {hasConfirmation
            ? "Thank you. Your order is confirmed."
            : "Order confirmation"}
        </h1>
        <p className="payment-success__intro">
          {hasConfirmation
            ? "We have received your order and will send delivery updates to the contact details provided at checkout."
            : "This confirmation link does not include an order reference. If you completed checkout, please check your confirmation email."}
        </p>

        {hasConfirmation && (
          <dl className="payment-success__reference">
            <div>
              <dt>Order number</dt>
              <dd>{orderNumber}</dd>
            </div>
            <div>
              <dt>Dispatch</dt>
              <dd>{siteConfig.shipping.dispatchWindow}</dd>
            </div>
          </dl>
        )}

        <div className="payment-success__steps" aria-label="What happens next">
          <div>
            <span>01</span>
            <p>
              <strong>Confirmation</strong>
              Your order details are recorded.
            </p>
          </div>
          <div>
            <span>02</span>
            <p>
              <strong>Preparation</strong>
              We carefully prepare your pieces.
            </p>
          </div>
          <div>
            <span>03</span>
            <p>
              <strong>Tracked delivery</strong>
              Tracking follows as soon as the parcel leaves us.
            </p>
          </div>
        </div>

        <div className="payment-success__actions">
          <Link to="/shop" onClick={scrollToTop}>
            Continue shopping
          </Link>
          <Link to="/shipping" onClick={scrollToTop}>
            Delivery information
          </Link>
        </div>
        <p className="payment-success__help">
          Need help?{" "}
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
        </p>
      </section>
    </main>
  );
};

export default PaySuccess;
